(()=>{
    var dateObj = new Date()
    let month = ('0'+(dateObj.getUTCMonth() + 1)).slice(-2)
    let day = ('0'+dateObj.getUTCDate()).slice(-2)
    let year = dateObj.getUTCFullYear()
    var nowDateString = parseInt(''+year+''+month+''+day)
    
    document.querySelectorAll('[data-dates-card]').forEach((node)=>{
      var dates = node.getAttribute('data-dates-card').split(',')
      
      var lowestDate = null
      var highestDate = null
      for(var i = 0;i < dates.length;i++){
        if(nowDateString <= parseInt(dates[i])){
          if(lowestDate == null || parseInt(dates[i]) < parseInt(lowestDate)){
            lowestDate = dates[i]
          }
          if(highestDate == null || parseInt(dates[i]) > parseInt(highestDate)){
            highestDate = dates[i]
          }
        }
      }

      if(lowestDate != null){
        var options = {month: 'short', day: 'numeric'}
        var dateObj = new Date()
        dateObj.setDate(parseInt(lowestDate.slice(-2)))
        dateObj.setMonth(parseInt(lowestDate.slice(4,6))-1)
        dateObj.setFullYear(parseInt(lowestDate.slice(0,4)))
        var dateString = dateObj.toLocaleDateString("en-GB", options)
        if(lowestDate !== highestDate){
          dateString += ' - '
          dateObj = new Date()
          dateObj.setDate(parseInt(highestDate.slice(-2)))
          dateObj.setMonth(parseInt(highestDate.slice(4,6))-1)
          dateObj.setFullYear(parseInt(highestDate.slice(0,4)))
          dateString += dateObj.toLocaleDateString("en-GB", options)
        }
        node.innerHTML = dateString
        if(node.closest('.events-card')){
          if(node.closest('.events-card').getAttribute('data-order') == null || node.closest('.events-card').getAttribute('data-order') == ''){
            node.closest('.events-card').setAttribute('data-order',lowestDate)
          }
        }
        node.closest('.swiper-slide')?.setAttribute('data-order',node.closest('.events-card').getAttribute('data-order'))
      }
      else{
        node.innerHTML = 'N/A'
        var slide = node.closest('.swiper-slide')
        if(slide){
          slide.remove()
        }
        else{
          node.closest('.events-card').remove()
        }
      }
    })
    document.querySelectorAll('[data-locations-event-date]').forEach((node)=>{
      var data = node.getAttribute('data-locations-event-date').split('||')
      var html = []
      var count = 0

      for(var i = 0;i < data.length;i++){
        var split = data[i].split('|')
        if(nowDateString <= parseInt(split[0]) && count < 10){
          html.push(split[1])
          count+=1
        }
        else if(count >= 10){
          break
        }
      }

      node.innerHTML = html.filter((value, index, array)=>{
        return array.indexOf(value) === index 
      }).join(', ')
    })
    document.dispatchEvent(new CustomEvent("js_dates_fixed"))
})()